import { z } from "zod";
import { IdSchema, IsoDateTimeSchema } from "../common/primitives.js";
const EventTypeSchema = z.string().max(100).regex(/^[a-z][a-z0-9_]*(\.[a-z][a-z0-9_]*)+$/, "event type must look like aggregate.past_tense");
const EventEnvelopeSchema = z.strictObject({
  id: IdSchema,
  type: EventTypeSchema,
  tenantId: IdSchema,
  occurredAt: IsoDateTimeSchema,
  actorUserId: IdSchema.nullable(),
  data: z.unknown()
});
function defineEvent(type, schema) {
  EventTypeSchema.parse(type);
  return {
    type,
    schema,
    parse(envelope) {
      if (envelope.type !== type) throw new Error(`expected event ${type}, got ${envelope.type}`);
      return { ...envelope, data: schema.parse(envelope.data) };
    }
  };
}
export {
  EventEnvelopeSchema,
  EventTypeSchema,
  defineEvent
};
//# sourceMappingURL=index.js.map